import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/components/SEO.tsx";
import { TokenomicsHero } from "@/components/tokenomics/TokenomicsHero";
import { TokenomicsDetails } from "@/components/tokenomics/TokenomicsDetails";
import { TokenDistribution } from "@/components/tokenomics/TokenDistribution";
import { ContractAddresses } from "@/components/tokenomics/ContractAddresses";
import { BurnSection } from "@/components/tokenomics/BurnSection";
import { DecentralizedSection } from "@/components/tokenomics/DecentralizedSection";
import { TokenDetails } from "@/components/tokenomics/TokenDetails";
import { FooterSection } from "@/components/FooterSection.tsx";

export const Route = createFileRoute("/tokenomics")({
	component: TokenomicsPage,
});

function TokenomicsPage() {
	return (
		<div className="min-h-screen">
			<SEO
				title="Tokenomics"
				description="LTAI token details — distribution, contract addresses, burn mechanism, and decentralized governance. The utility token powering the LibertAI ecosystem."
				path="/tokenomics"
			/>
			<TokenomicsHero />
			<TokenomicsDetails />
			<ContractAddresses />
			<DecentralizedSection />
			<TokenDistribution />
			<BurnSection />
			<TokenDetails />
			<FooterSection />
		</div>
	);
}
